<template>
  <div class="home">
    <!--    <b-container>-->
    <!--      &lt;!&ndash;      <img src="../images/bg-masthead.jpg" alt="">&ndash;&gt;-->
    <!--      &lt;!&ndash; img here &ndash;&gt;-->
    <!--    </b-container>-->
    <!-- intro -->
    <!--    <section class="pb-lg-5 pt-lg-5 bg-white" :style="{'background-image':'url(https://vuejs.org/images/logo.png)'}" id="platform">-->
    <section bg-variant="white" class="b-jumbotron">
      <b-jumbotron bg-variant="white">
        <template v-slot:header><h1 style="font-weight: bold">CultureLabs Platform</h1></template>
        <template v-slot:lead>
          <h3>Recipes for social innovation</h3>
        </template>
        <div class="mt-4">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/cY9iHC2JRKA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <!--        <h4>-->
        <!--          The CultureLabs platforms offers tools and material that can help you structure <br>-->
        <!--          and collaborative organise participatory projects.-->
        <!--          </h4>-->
        <!--        <b-button :to="{ name: 'whatWeOffer'}" class="bg-orange" size="lg">What We Offer-->
        <!--        </b-button>-->
      </b-jumbotron>
    </section>

    <!-- Services -->
    <section style="margin-top: -30px" class="text-white text-center" id="services">
      <b-container>
        <div class="">
          <!--          <div class="content-section-heading">-->
          <!--            <h2 class="mb-4">CultureLabs Platform Services</h2>-->
          <!--          </div>-->
          <div class="row">
            <div class="col-lg-4 col-md-6 mb-lg-4">
              <!--            <div class="col-lg-6 col-md-6 mb-lg-6">-->
              <!--              <font-awesome-icon icon="thumbs-up" size="4x" class="mb-4"/>-->
              <b-link @click="globalSearchHome" class="text-white">
                <font-awesome-icon class="mb-4" icon="search" size="4x"/>
              </b-link>
              <h4>
                <!--                                <b-link @click.prevent="scrollTo('featured-recipes')" href="#" class="text-white">Featured Recipes</b-link>-->
                <b-link @click="globalSearchHome" class="text-white">Discover
                </b-link>
              </h4>
              <p class="ml-4 text-faded mb-0">
                <!--                Easy access to featured, public recipes.-->
                Discover information about participatory projects for social innovation in the field of Cultural
                Heritage and beyond.
                <br>
                Find out not only successful outcomes but also the "inside" information.
              </p>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-4">
              <!--            <div class="col-lg-6 col-md-6 mb-lg-6">-->
              <!--              <font-awesome-icon @click="globalSearchHome" icon="search" size="" class="mb-4"/>-->
              <b-link :to="{ name: 'recipes' }" class="text-white">
                <font-awesome-icon class="mb-4" icon="edit" size="4x"/>
              </b-link>
              <h4>
                <b-link :to="{ name: 'recipes' }" class="text-white">Create</b-link>
              </h4>
              <p class="text-faded mb-0">
                <!--                Search for recipes and ingredients using multiple criteria-->
                Document and structure participatory projects as recipes. <br>
                Upload helpful resources as ingredients. Make them public so that others can benefit from that
                knowledge.
              </p>
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-4">
              <b-link :to="{ name: 'recipes' }" class="text-white">
                <font-awesome-icon class="mb-4" icon="handshake" size="4x"/>
              </b-link>
              <h4>
                <!--                <b-link @click.prevent="scrollTo('featured-ingredients')" class="text-white">Featured Ingredients</b-link>-->
                <b-link :to="{ name: 'recipes' }" class="text-white">Collaborate</b-link>
              </h4>
              <!--              <p class="text-faded mb-0">Easy access to featured, public ingredients. </p>-->
              <p class="text-faded mb-0">Share your projects and resources with other users, ask for feedback, and
                collaborate with them on common projects. <br>
                Find potential collaborators and get involved in projects of other organisations.
              </p>
            </div>
          </div>

          <br>

          <div class="row">
            <!--            <div class="col-lg-6 col-md-6 mb-lg-6" v-b-modal.modal-sm>-->
            <div class="col-lg-4 col-md-6 mb-lg-4">
              <a href="http://recipes.culture-labs.eu/forum/" target="_blank" class="text-white">
                <font-awesome-icon class="mb-4" icon="comments" size="4x"/>
              </a>
              <h4>
                <!--                <b-link @click.prevent="scrollTo('featured-ingredients')" class="text-white">Featured Ingredients</b-link>-->
                <a href="http://recipes.culture-labs.eu/forum/" target="_blank" class="text-white">Communicate</a>
              </h4>
              <!--              <p class="text-faded mb-0">Easy access to featured, public ingredients. </p>-->
              <p class="ml-4 text-faded mb-0">Communicate and exchange ideas.<br>
                Discuss your topics of interest in the <a class="text-white font-weight-bold"
                                                          href="http://recipes.culture-labs.eu/forum/" target="_blank">forum</a>.
                <br>
                <i>Rating and Commenting services under development.</i>
              </p>
            </div>

            <!--            <div class="col-lg-6 col-md-6 mb-lg-6" v-b-modal.modal-sm>-->
            <div class="col-lg-4 col-md-6 mb-lg-4">
              <b-link :to="{ name: 'recipes' }" class="text-white">
                <font-awesome-icon class="mb-4" icon="copy" size="4x"/>
              </b-link>
              <h4>
                <b-link :to="{ name: 'recipes' }" class="text-white">Reuse</b-link>
              </h4>
              <p class="text-faded mb-0">Copy an existing project and customise it to your own needs. <br>
                Reuse and combine resources uploaded by others and complement them with your own material in order to
                build a new participatory project.
              </p>
              <!--              <b-modal id="modal-sm" ok-only size="md">Rating and Commenting services under development.-->
              <!--              </b-modal>-->
            </div>

            <div class="col-lg-4 col-md-6 mb-lg-4">
              <b-link :to="{ name: 'whatWeOffer' }" class="text-white">
                <font-awesome-icon class="mb-4" icon="info" size="4x"/>
              </b-link>
              <h4>
                <b-link :to="{ name: 'whatWeOffer' }" class="text-white">Find out more</b-link>
              </h4>
              <p class="text-faded mb-0">Further information about CultureLabs. <br>
                <router-link style="color: white; font-weight: bold" to="/workspace/what-we-offer">What We Offer
                </router-link>
              </p>
              <!--              <b-modal id="modal-sm" ok-only size="md">Rating and Commenting services under development.-->
              <!--              </b-modal>-->
            </div>
          </div>
        </div>
      </b-container>
    </section>

    <!-- Featured recipes list -->
    <section class="mt-lg-3 mb-lg-3" id="featured-recipes-container">
      <b-container>
        <div class="text-center">
          <h3 class="mb-2">Featured Recipes</h3>
        </div>
        <div ref="featured-recipes">
          <b-row align-v="start">
            <b-col cols="12" lg="3" md="4" sm="6" v-bind:key="recipe.id" v-for="recipe in recipes" xs="12">
              <FeaturedRecipeCard
                class="recipe-container m-1"
                v-bind:recipe="recipe">
              </FeaturedRecipeCard>
            </b-col>
          </b-row>
        </div>
<!--      </b-container>-->
<!--      <b-container>-->
        <div class="overflow-auto" v-if="showRecipePagination">
          <b-pagination
            :per-page="recipesPagination.pageSize"
            :total-rows="recipesPagination.totalCount"
            @input="getFeaturedRecipes"
            align="center"
            first-text="First"
            last-text="Last"
            next-text="Next"
            prev-text="Prev"
            v-model="recipesPagination.currentPage"/>
        </div>
      </b-container>
    </section>

    <section class="mt-lg-5 mb-lg-3" id="featured-ingredients-container">
      <b-container>
        <div class="text-center">
          <h3 class="mb-2">Featured Ingredients</h3>
        </div>
        <div ref="featured-ingredients">
          <b-row align-v="start">
            <b-col cols="12" lg="3" md="4" sm="6" v-bind:key="resource.id" v-for="resource in resources" xs="12">
              <FeaturedIngredientsCard
                class="resource-container m-2"
                v-bind:resource="resource">
              </FeaturedIngredientsCard>
            </b-col>
          </b-row>
        </div>
<!--      </b-container>-->
<!--      <b-container>-->
        <div class="overflow-auto" v-if="showResourcePagination">
          <b-pagination
            :per-page="resourcesPagination.pageSize"
            :total-rows="resourcesPagination.totalCount"
            @input="getFeaturedResources"
            align="center"
            first-text="First"
            last-text="Last"
            next-text="Next"
            prev-text="Prev"
            v-model="resourcesPagination.currentPage"/>
        </div>
      </b-container>
    </section>

    <section class="text-white text-center pt-lg-5 pb-lg-5" id="tools" v-if="false">
      <!-- More tools: by default this section is not rendered -->
      <b-container>
        <div>
          <h2 class="mb-4">
            <b-link :href="links.forumUrl" style="color:white" target="_blank">
              Contribute with your ideas (Forum)
            </b-link>
          </h2>
          <h2 class="mb-4">
            <b-link :href="links.culturalHeritageUrl" style="color:white" target="_blank">
              Creative interaction with Cultural Heritage (WITH)
            </b-link>
          </h2>
          <h2 class="mb-4">
            <b-link :href="links.wotifyUrl" style="color:white" target="_blank">
              Experiment with co-creation tools (Wotify)
            </b-link>
          </h2>
        </div>
      </b-container>
    </section>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
import FeaturedRecipeCard from '../components/recipes/FeaturedRecipeCard'
import FeaturedIngredientsCard from '../components/resources/FeaturedIngredientsCard'
import Footer from '../components/Footer'
import SearchPlugin from '../plugins/SearchPlugin'

export default {
  name: 'home',
  components: {
    FeaturedRecipeCard,
    FeaturedIngredientsCard,
    Footer
  },
  data () {
    return {
      links: {
        'forumUrl': 'https://www.phpbb.com/demo/',
        'culturalHeritageUrl': 'hhttp://withculture.eu',
        'wotifyUrl': 'https://wotify.co/'
      },
      recipes: [],
      recipesPagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 4
      },
      resources: [],
      resourcesPagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 4
      }
    }
  },
  created () {
    // get featured recipes
    this.getFeaturedRecipes()
    this.getFeaturedResources()
  },
  beforeMount () {
    SearchPlugin.event.$on('updateterm', this.changeTerm)
    SearchPlugin.event.$on('showView', this.showView)
  },
  computed: {
    showRecipePagination: function () {
      return this.recipesPagination.totalCount > this.recipesPagination.pageSize
    },
    showResourcePagination: function () {
      return this.resourcesPagination.totalCount > this.resourcesPagination.pageSize
    }
  },
  methods: {
    globalSearchHome () {
      this.search = 'global'
      this.showAll()
    },
    scrollTo (refName) {
      let element = this.$refs[refName]
      let top = element.offsetTop
      window.scrollTo(0, top)
    },
    initFeaturedRecipes: function () {
      this.recipes = []
    },
    getFeaturedRecipes: function () {
      // Fetch the list of featured recipes
      let params = {
        status: 'FEATURED',
        start: this.recipesPagination.pageSize * (this.recipesPagination.currentPage - 1),
        count: this.recipesPagination.pageSize
      }
      // get data
      let tempRecipes = []
      this.$store.dispatch('getRecipesList', params).then(
        data => {
          // this.tempRecipes = data.results
          this.recipesPagination.totalCount = data.totalCount
          this.initFeaturedRecipes()
          this.recipes = data.results
          // get resource for each recipe
          // tempRecipes.forEach(
          //   recipe => {
          //     let temp = recipe
          //     this.$store.dispatch('getResourceEntity', temp.imageResource).then(
          //       resource => {
          //         temp.resource_url = resource.url
          //         temp.isShared = false
          //         this.recipes.push(temp)
          //       })
          //   }
          // )
        })
    },
    initFeaturedResources: function () {
      this.resources = []
    },
    getFeaturedResources: function () {
      // Fetch the list of featured resources
      let params = {
        status: 'FEATURED',
        start: this.resourcesPagination.pageSize * (this.resourcesPagination.currentPage - 1),
        count: this.resourcesPagination.pageSize
      }
      // get data
      this.$store.dispatch('getResourcesList', params).then(
        data => {
          this.resourcesPagination.totalCount = data.totalCount
          this.initFeaturedResources()
          this.resources = data.results
        })
    },
    changeTerm (val) {
      this.sTerm = val
    },
    showAll: function (token) {
      this.$search.searchNow()
    },
    showSearch: function () {
      this.$search.toggleSearch()
    },
    showView: function (event) {
      if (this.search === 'global') {
        if (event.detail.type === 'Organisation') {
          this.$router.push({name: 'organizationView', params: {id: event.detail.id}})
        } else if (event.detail.type === 'Recipe') {
          this.$router.push({name: 'recipeView', params: {id: event.detail.id}})
        } else if (event.detail.type === 'Resource') {
          this.$router.push({name: 'resourceView', params: {id: event.detail.id}})
        }
        this.search = ''
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token
      }
      )
    },
    searchTerm: function (term, relttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token
      }
      )
    }
  }
}
</script>

<style scoped>
  #services, #tools {
    background-color: #1d809f !important;
  }

  .recipe-container, .resource-container {
    border: 1px solid #eeeff0;
    min-width: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue